// Smit: 24-11

const { SET_SUCCESS, SET_ERROR } = require("./actionTypes");

const initialState = {
  successMessage: "",
  errorMessage: "",
};

const commonReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_SUCCESS:
      return {
        ...state,
        successMessage: payload,
      };
    case SET_ERROR:
      return {
        ...state,
        errorMessage: payload,
      };
    default:
      return state;
  }
};

export default commonReducer;
